import SocialLinks from './socialLinks'

export default SocialLinks
